import React, { useState } from 'react';
import PropTypes from 'prop-types';
import EducationCard from '@components/molecules/education/card/educationCard';
import { connectInfiniteHits } from 'react-instantsearch-dom';
import Headline from '@components/atoms/headline/headline';
import { AngleDown } from '@components/icons/arrow/arrow';
import StyledEducationRefinementHits from './educationRefinementHits.style';
import { CustomClearRefinements } from '../refinement/educationRefinement';
import { EducationLibraryFilterContext } from '../../../organisms/education/library-filter/educationLibraryFilter';

const InfiniteHits = ({ hits, hasMore, refineNext, disableClearFilter = false }) => {
  const [isFilterReset, setIsFilterReset] = useState(false);

  return (
    <StyledEducationRefinementHits>
      <div className="hits__grid">
        {hits.length > 0 ? (
          <>
            {hits.map(hit => (
              <EducationCard
                key={hit.objectID}
                title={hit.title}
                image={hit.image}
                copy={hit.introCopy}
                uri={hit.uri}
                contentType={hit.educationType}
                topics={hit.educationTopics}
              />
            ))}
          </>
        ) : (
          <div className="hits__not-found">
            <Headline tag="span" className="hits__not-found-title">
              Keine Einträge gefunden :/
            </Headline>
            <EducationLibraryFilterContext.Provider
              value={{
                isFilterReset,
                setIsFilterReset
              }}
            >
              {!disableClearFilter && <CustomClearRefinements title="Filter zurücksetzen" />}
            </EducationLibraryFilterContext.Provider>
          </div>
        )}
      </div>
      {hasMore && (
        <div className="hits__load-more">
          <button
            type="button"
            className="hits__load-more-button"
            onClick={refineNext}
            disabled={!hasMore}
          >
            <Headline tag="span">Mehr anzeigen</Headline>
            <AngleDown />
          </button>
        </div>
      )}
    </StyledEducationRefinementHits>
  );
};

InfiniteHits.propTypes = {
  hits: PropTypes.arrayOf(
    PropTypes.shape({
      objectID: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.shape({
        src: PropTypes.string,
        title: PropTypes.string,
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      }),
      introCopy: PropTypes.string.isRequired,
      uri: PropTypes.string.isRequired,
      educationTopics: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          title: PropTypes.string.isRequired
        })
      ).isRequired,
      educationType: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          slug: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ),
  hasMore: PropTypes.bool.isRequired,
  disableClearFilter: PropTypes.bool,
  refineNext: PropTypes.func.isRequired
};

const CustomInfiniteHits = connectInfiniteHits(InfiniteHits);

export default CustomInfiniteHits;
